import React, { useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';

import { Error } from '../../design/elements';
import FormField from '../formField';
import { BrpGroupWrapper, BrpGroupTitle } from '../css';

const UserDetailsForm = ({
  data,
  formErrors = {},
  formFields,
  orderData,
  setFormFields,
  isEditing,
  isFormTouched,
  setIsFormTouched
}) => {
  const { name, formStepFields } = data;

  function camelize(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, '');
  }

  const handleFormField = (fieldName, value, type) => {
    const fields = { ...formFields };
    if (type === 'AddressDetails' && typeof value === 'object') {
      Object.keys(value).forEach(key => {
        fields[camelize(`brpServiceAddress ${key}`)] = {
          ...fields[fieldName],
          value: value[key]
        };
      });
    } else {
      fields[fieldName] = { ...fields[fieldName], value };
    }
    if (!isFormTouched) {
      setIsFormTouched(true);
    }
    setFormFields(fields);
  };

  useEffect(() => {
    if (isEditing && orderData && orderData.id) {
      const fields = { ...formFields };
      formStepFields.forEach(({ fields: { name: fieldName } }) => {
        fields[fieldName] = {
          ...fields[fieldName],
          value: orderData[fieldName]
        };
      });
      setFormFields(fields);
      if (isFormTouched) setIsFormTouched(false);
    }
  }, [isEditing, orderData]);

  return (
    <BrpGroupWrapper>
      <BrpGroupTitle>{name}</BrpGroupTitle>
      {formStepFields.map(({ fields, sys: { id: sysId } }, index) => {
        const key = `UserDetails${name}${index}`;
        const error = formErrors[fields.name];

        const fieldData = {
          ...fields,
          value: formFields[fields.name] && formFields[fields.name].value,
          disabled: false,
          sysId,
          onChange: ({ target: { name: fieldName, value } }) => {
            handleFormField(fieldName, value, fields.type);
          }
        };
        return (
          <Fragment key={key}>
            <FormField data={fieldData} />
            {error && error.text && <Error text={error.text} />}
          </Fragment>
        );
      })}
    </BrpGroupWrapper>
  );
};

UserDetailsForm.propTypes = {
  data: PropTypes.shape({
    formStepFields: PropTypes.arrayOf(PropTypes.object),
    name: PropTypes.string.isRequired
  }).isRequired,
  formErrors: PropTypes.objectOf(PropTypes.object),
  formFields: PropTypes.objectOf(PropTypes.object).isRequired,
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  setFormFields: PropTypes.func.isRequired,
  isEditing: PropTypes.string.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  setIsFormTouched: PropTypes.func.isRequired
};

export default UserDetailsForm;
